import { 
  REQUEST_FAQS,
  RECEIVE_FAQS,
} from '../constants/actionTypes';

// import { apiFaqs as api } from '../api';
import { faqs } from '../constants/faq';

export const requestFaqs = () => ({
  type: REQUEST_FAQS,
});

export const receiveFaqs = (response) => ({
  type: RECEIVE_FAQS,
  response
});

// For live
export function fetchFaqs() {
  return function(dispatch) {
    dispatch(requestFaqs());
    dispatch(receiveFaqs(faqs));
    // return api.get()
    //     .then((response) => {
    //         dispatch(receiveFaqs(fakeFaqApi));
    //     })
    //     .catch((err) => {
    //         dispatch(receiveErrorResponse(err));
    //     });
  };
}